import { getSetting } from "@/api/setting";
import titleControl from "@/utils/titleControl";
export default {
  namespaced: true,
  state: {
    data: null,
  },
  mutations: {
    setData(state, payload) {
      state.data = payload;
    },
  },
  actions: {
    async getData(ctx) {
      const res = await getSetting();
      ctx.commit("setData", res.data.data);
      titleControl.setSiteTitle(res.data.data.siteTitle);
      // const link = document.querySelector("link[rel='shortcut icon']");
      // if(res.favicon){
      //   let link = document.querySelector("link[rel='shortcut icon']");
      //   if(link){
      //     return
      //   }
      // }
      if (res.data.data.favicon) {
        const isLink = document.querySelector("link[rel='shortcut icon']");
        if (isLink) {
          return;
        }
      }
      let link = document.createElement("link");
      link.rel = "shortcut icon";
      link.type = "images/x-icon";
      link.href = res.data.data.favicon;
      document.querySelector("head").appendChild(link);
    },
  },
};
